The response from the `updatePositionOpeningPersonContacts` mutation.
